function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import map from 'lodash/map';
import get from 'lodash/get';
import toLower from 'lodash/toLower';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Select from 'components/Form/Select';
import App from 'modules/App';
import styles from './PhiSetFormPartial.pcss';
var _React_PureComponent;
class PhiSetFormPartial extends (_React_PureComponent = React.PureComponent) {
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.phiSetFormPartial,
            children: [
                !this.props.hasCentralStorage && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(FormGroup, {
                            id: "diabetesType",
                            labelMessage: App.messages.labels.diabetesType,
                            formValues: this.props.formValues,
                            children: /*#__PURE__*/ _jsx(Select, {
                                optionsFrom: map(App.constants.DIABETES_TYPES, (value)=>({
                                        value,
                                        label: get(this.props.localizationResources, `diabetesType_${toLower(value)}.value`, value)
                                    })),
                                hiddenValues: [
                                    ...this.props.isActiveProfileTypePwd ? App.constants.DIABETES_TYPES_HIDE_FOR_PWD : App.constants.DIABETES_TYPES_HIDE_FOR_HCP,
                                    ...this.props.isMale ? App.constants.DIABETES_TYPES_HIDE_FOR_MALE : []
                                ],
                                valueKey: "value",
                                labelKey: "label",
                                noValueMessage: App.messages.placeholders.diabetesType,
                                onChange: this.props.onSetFormValue,
                                isDisabled: this.props.isDisabledDiabetesType,
                                isListInverted: this.props.isListInverted
                            })
                        }),
                        /*#__PURE__*/ _jsx(FormGroup, {
                            id: "treatmentType",
                            labelMessage: App.messages.labels.treatmentType,
                            formValues: this.props.formValues,
                            children: /*#__PURE__*/ _jsx(Select, {
                                optionsFrom: map(App.constants.TREATMENT_TYPES, (value)=>({
                                        value,
                                        label: get(this.props.localizationResources, `treatmentType_${toLower(value)}.value`, value)
                                    })),
                                valueKey: "value",
                                labelKey: "label",
                                noValueMessage: App.messages.placeholders.treatmentType,
                                onChange: this.props.onSetFormValue,
                                isDisabled: this.props.isDisabledTreatmentType,
                                isListInverted: this.props.isListInverted
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "weight",
                    labelMessage: _object_spread_props(_object_spread({}, App.messages.labels.weight), {
                        values: {
                            units: this.props.metricConversions.weight.unitSymbol
                        }
                    }),
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(Input, {
                        type: "number",
                        placeholder: App.messages.placeholders.weight,
                        onChange: this.props.onSetFormValue
                    })
                }),
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "height",
                    labelMessage: _object_spread_props(_object_spread({}, App.messages.labels.height), {
                        values: {
                            units: this.props.metricConversions.height.unitSymbol
                        }
                    }),
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(Input, {
                        type: "number",
                        placeholder: App.messages.placeholders.height,
                        onChange: this.props.onSetFormValue
                    })
                })
            ]
        });
    }
}
_define_property(PhiSetFormPartial, "propTypes", {
    // Explicit props
    metricConversions: PropTypes.shape({
        weight: PropTypes.object,
        height: PropTypes.object
    }),
    formValues: PropTypes.object,
    hasCentralStorage: PropTypes.bool,
    isDisabledDiabetesType: PropTypes.bool,
    isDisabledTreatmentType: PropTypes.bool,
    isActiveProfileTypePwd: PropTypes.bool,
    isMale: PropTypes.bool,
    isListInverted: PropTypes.bool,
    localizationResources: PropTypes.object,
    // Explicit actions
    onSetFormValue: PropTypes.func
});
_define_property(PhiSetFormPartial, "defaultProps", {
    hasCentralStorage: false,
    isDisabledDiabetesType: false,
    isDisabledTreatmentType: false
});
export default withStyles(styles)(injectIntl(PhiSetFormPartial));
